// @mui
import { enUS, frFR, zhCN, viVN, arSD } from '@mui/material/locale';
// routes
import {ADMIN_PATH_DASHBOARD, PATH_DASHBOARD} from './routes/paths';
import { processEnv } from './env';

// API
// ----------------------------------------------------------------------

export const HOST_API = processEnv.REACT_APP_HOST_API_KEY || '';
export const REACT_APP_GUIDELINE_URL = processEnv.REACT_APP_GUIDELINE_URL || '';

export const FIREBASE_API = {
  apiKey: processEnv.REACT_APP_FIREBASE_API_KEY,
  authDomain: processEnv.REACT_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: processEnv.REACT_APP_FIREBASE_DATABASE_URL,
  projectId: processEnv.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: processEnv.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: processEnv.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: processEnv.REACT_APP_FIREBASE_APPID,
  measurementId: processEnv.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

export const COGNITO_API = {
  userPoolId: processEnv.REACT_APP_AWS_COGNITO_USER_POOL_ID,
  clientId: processEnv.REACT_APP_AWS_COGNITO_CLIENT_ID,
};

export const AUTH0_API = {
  clientId: processEnv.REACT_APP_AUTH0_CLIENT_ID,
  domain: processEnv.REACT_APP_AUTH0_DOMAIN,
};

export const MAPBOX_API = processEnv.REACT_APP_MAPBOX_API;

// ROOT PATH AFTER LOGIN SUCCESSFUL
export const PATH_AFTER_LOGIN = PATH_DASHBOARD.general.testToDo;
export const ADMIN_PATH_AFTER_LOGIN = ADMIN_PATH_DASHBOARD.general.account

// LAYOUT
// ----------------------------------------------------------------------

export const HEADER = {
  MOBILE_HEIGHT: 64,
  MAIN_DESKTOP_HEIGHT: 88,
  DASHBOARD_DESKTOP_HEIGHT: 92,
  DASHBOARD_DESKTOP_OFFSET_HEIGHT: 92 - 32,
};

export const NAVBAR = {
  BASE_WIDTH: 260,
  DASHBOARD_WIDTH: 320,
  DASHBOARD_COLLAPSE_WIDTH: 88,
  //
  DASHBOARD_ITEM_ROOT_HEIGHT: 48,
  DASHBOARD_ITEM_SUB_HEIGHT: 40,
  DASHBOARD_ITEM_HORIZONTAL_HEIGHT: 32,
};

export const ICON = {
  NAVBAR_ITEM: 22,
  NAVBAR_ITEM_HORIZONTAL: 20,
};

// SETTINGS
// Please remove `localStorage` when you change settings.
// ----------------------------------------------------------------------

export const defaultSettings = {
  themeMode: 'light',
  themeDirection: 'ltr',
  themeContrast: 'default',
  themeLayout: 'horizontal',
  themeColorPresets: 'default',
  themeStretch: false,
};

// MULTI LANGUAGES
// Please remove `localStorage` when you change settings.
// ----------------------------------------------------------------------

export const allLangs = [
  {
    label: 'English',
    value: 'en',
    systemValue: enUS,
    // icon: '/assets/icons/flags/ic_flag_en.svg',
  },
  {
    label: 'French',
    value: 'fr',
    systemValue: frFR,
    // icon: '/assets/icons/flags/ic_flag_fr.svg',
  },
  {
    label: 'Vietnamese',
    value: 'vn',
    systemValue: viVN,
    // icon: '/assets/icons/flags/ic_flag_vn.svg',
  },
  {
    label: 'Chinese',
    value: 'cn',
    systemValue: zhCN,
    // icon: '/assets/icons/flags/ic_flag_cn.svg',
  },
  {
    label: 'Arabic (Sudan)',
    value: 'ar',
    systemValue: arSD,
    // icon: '/assets/icons/flags/ic_flag_sa.svg',
  },
];

export const defaultLang = allLangs[0]; // English
